"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMaps = _interopRequireDefault(require("../../common/keyMaps"));

var handleKeyDown = function handleKeyDown(onClick, action) {
  return function (ev) {
    if (ev.keyCode === _keyMaps.default.ENTER) {
      if (onClick) {
        onClick(ev);
      }

      if (action) {
        action();
      }
    } else if (ev.keyCode === _keyMaps.default.SPACE) {
      ev.preventDefault();

      if (onClick) {
        onClick(ev);
      }

      if (action) {
        action();
      }
    }
  };
};

var _default = handleKeyDown;
exports.default = _default;